import { SettingsLayout } from "@/components/layout/SettingsLayout";
import { ProviderSettings } from "@/components/settings/ProviderSettings";

export function ProvidersPage() {
  return (
    <SettingsLayout>
      <ProviderSettings />
    </SettingsLayout>
  );
}
